<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      No matter your role in Law, developing your typing skills will help you improve your
      effectiveness in your job.
    </p>

    <div class="overflow-hidden">
      <img
        src="@/assets/images/experiences/law/typing.jpg"
        alt=""
        class="my-2 ml-2 mb-2 float-right"
      />
      <p class="mb-5">
        The legal field generates a lot of documents, and the faster you can put them together, the
        better you will function and the more you will get done. This is especially important when
        there are hearings or trials coming up because most courts only have limited judges and
        times available. If a lawyer and their team don’t have all the documents ready, they might
        have to postpone the trial, which may not benefit their client.
      </p>

      <p class="mb-5">
        Learning to touch type significantly increases your typing accuracy, and accuracy is of
        critical importance in any legal document. Something filed in the court can have the force
        of law behind it, and if you’ve missed a word in a document, there could be severe
        consequences. Just think about typing a will and accidentally changing the directive “I do
        not want my house to go to my brother” by omitting the word “not” – that could probably
        spark family feuds that may burn for generations!
      </p>
    </div>

    <p class="mb-5">
      Luckily, all these problems can be avoided by learning to touch type with speed and accuracy.
      Fortunately, there are online programmes that can help you develop your skills in this area.
      One of the best is Ratatype.
    </p>

    <p class="mb-5">
      When you click the link below, you’ll be taken to a quick assessment of your typing abilities.
      It will tell you your current typing speed in words per minute (WPM). Record your WPM rate
      below:
    </p>
    <button-link-wrapper text="Take the Typing Test" link="https://www.ratatype.com/typing-test/" />

    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2"><strong>Initial WPM: </strong></p>
      <text-block
        v-model="data['question1']"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
    </div>

    <p class="mb-5">
      After you do the short assessment, it’s time to practice. By clicking the link below, you’ll
      be taken to the online typing tutor Ratatype. Here, you’ll be able to access lessons and
      undertake practice sessions to improve your speed and accuracy. Ratatype will record your
      progress and help guide you on the path to competency.
    </p>
    <p class="mb-5">
      The more you practise, the quicker your progress will be. Try to practise a minimum of 20
      minutes per day for the 7 days. On Day 7, check your WPM typing rate and record your answer
      below:
    </p>
    <button-link-wrapper
      text="Use the Typing Tutor"
      link="https://www.ratatype.com/#typing-tutor"
    />

    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2"><strong>Day 7 WPM: </strong></p>
      <text-block
        v-model="data['question2']"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
    </div>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
